"use client"

import { motion } from "framer-motion"
import { FaBriefcase, FaUsers, FaBalanceScale, FaHandshake, FaBuilding, FaGavel } from "react-icons/fa"

const iconMap = {
  briefcase: FaBriefcase,
  users: FaUsers,
  balance: FaBalanceScale,
  handshake: FaHandshake,
  building: FaBuilding,
  gavel: FaGavel,
}

const AreasPractica = ({ areas }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="space-y-8"
    >
      <h2 className="text-2xl font-bold">Áreas de Práctica</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {areas.map((area, index) => {
          const Icon = iconMap[area.icon] || FaBriefcase

          return (
            <motion.div
              key={area.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              className="bg-white rounded-lg shadow-md p-6"
            >
              <div className="flex items-center space-x-4 mb-4">
                <div className="bg-blue-100 rounded-lg p-3">
                  <Icon className="text-2xl text-[var(--gold)] " />
                </div>
                <h3 className="text-lg font-semibold">{area.name}</h3>
              </div>

              <p className="text-gray-600 mb-4">{area.description}</p>

              <div className="flex justify-between items-center">
                <div>
                  <p className="text-sm text-gray-500">Casos exitosos</p>
                  <p className="text-xl font-bold text-[var(--gold)] ">{area.successfulCases}+</p>
                </div>

                <button className="text-[var(--gold)]  hover:text-[var(--gold-dark)] text-sm font-medium">Más información</button>
              </div>
            </motion.div>
          )
        })}
      </div>
    </motion.div>
  )
}

export default AreasPractica

